export enum fileTypes {
  PDF = 'application/pdf',
  PNG = 'image/png',
  GIF = 'image/gif',
}

export enum fileExtention {
  PDF = 'pdf',
  PNG = 'png',
  GIF = 'gif',
}

export const fileExtentionMapper = {
  [fileTypes.PDF]: fileExtention.PDF,
  [fileTypes.PNG]: fileExtention.PNG,
  [fileTypes.GIF]: fileExtention.GIF,
}

export const fileTypesMapper = {
  [fileExtention.PDF]: fileTypes.PDF,
  [fileExtention.PNG]: fileTypes.PNG,
  [fileExtention.GIF]: fileTypes.GIF,
}
